export const tableauServer = import.meta.env.VITE_SERVER!;
export const site = import.meta.env.VITE_SITE!;
export const subscriber = import.meta.env.VITE_SUBSCRIBER!;
export const datasourceLuid = import.meta.env.VITE_DATASOURCE_LUID!;
export const appServer = import.meta.env.VITE_APP_SERVER ?? '';